import { render, staticRenderFns } from "./RoomSingle.vue?vue&type=template&id=55832905&"
import script from "./RoomSingle.vue?vue&type=script&lang=js&"
export * from "./RoomSingle.vue?vue&type=script&lang=js&"
import style0 from "./RoomSingle.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RoomSingle.vue"
export default component.exports